export const scrollToRef = (ref: any, offset = 0) => {
    if (ref) {
        window.scroll({
            top: ref.current.offsetTop + offset,
            left: 0,
            behavior: 'smooth',
        });
    }
};
